"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_property_decorator_1 = require("vue-property-decorator");
var axios_1 = __importDefault(require("axios"));
var DetailDataSingleLabel_1 = __importDefault(require("../contract_form/DetailDataSingleLabel"));
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var SalesForceButtonArea_1 = __importDefault(require("./SalesForceButtonArea"));
var DatePickerWrapper_1 = __importDefault(require("../datepicker/DatePickerWrapper"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
var ReflectType_1 = require("../../../common/src/types/sales_force/ReflectType");
var MoveSalesForceButton_1 = __importDefault(require("./MoveSalesForceButton"));
var SimpleDialog_1 = __importDefault(require("../globals/SimpleDialog"));
var PriceBookSelect_1 = __importDefault(require("./PriceBookSelect"));
var ProductSelect_1 = __importDefault(require("./ProductSelect"));
var Loading_1 = __importDefault(require("../../components/globals/Loading"));
var OpportunityUpgradeToStandardPre = /** @class */ (function (_super) {
    __extends(OpportunityUpgradeToStandardPre, _super);
    function OpportunityUpgradeToStandardPre() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.form = {};
        _this.showAlertDialog = false;
        _this.alertMessage = '';
        _this.showConfirmDialog = false;
        _this.confirmMessage = '';
        _this.salesForceInfo = {
            torihikisakiId: '',
            upgradeToStandardItFlg: '',
            upgradeToStandardTokubetuFlg: '',
            upgradeToStandardTokubetuDetail: '',
            upgradeToStandardPriceBook2Id: '',
            upgradeToStandardPriceBookData: [],
            upgradeToStandardData: [],
            upgradeToStandardFamilyName: [],
            validUpgradeToStandardFlg: '',
            upgradeToStandardBaseContractEndDate: ''
        };
        _this.upgradeToStandardPrice = '';
        _this.alertDialogMessage = '';
        _this.loading = false;
        // [Rehab Cloud]のみの価格表
        _this.rehabCloudPriceBook = [];
        return _this;
    }
    OpportunityUpgradeToStandardPre.prototype.refs = function () {
        return this.$refs;
    };
    OpportunityUpgradeToStandardPre.prototype.getTranslation = function (key) {
        return this.$t(key);
    };
    OpportunityUpgradeToStandardPre.prototype.parseDate = function (dateStr) {
        return date_parser_1.default.toJapaneseDateStr(dateStr);
    };
    OpportunityUpgradeToStandardPre.prototype.mounted = function () {
        this.initDataChange();
        this.initSalesForceDataChange();
        // 価格表 Rehab Cloud のみをSETする
        this.searchingRehabCloud();
    };
    OpportunityUpgradeToStandardPre.prototype.startLoading = function () {
        this.loading = true;
    };
    OpportunityUpgradeToStandardPre.prototype.endLoading = function () {
        this.loading = false;
    };
    OpportunityUpgradeToStandardPre.prototype.initDataChange = function () {
        this.form = this.initData;
    };
    OpportunityUpgradeToStandardPre.prototype.initSalesForceDataChange = function () {
        this.salesForceInfo = this.initSalesForceData;
    };
    OpportunityUpgradeToStandardPre.prototype.priceBook2IdChanged = function () {
        if (value_checker_1.default.isPresent(this.salesForceInfo.upgradeToStandardPriceBook2Id)) {
            // 必要な商品をSETする。
            this.defaultPriceBookData();
            // アップグレード対象商談の契約終了日を決定する
            this.decideUpgradeBaseDate();
        }
    };
    // 価格表を Rehab Cloud に限定する。
    OpportunityUpgradeToStandardPre.prototype.searchingRehabCloud = function () {
        this.rehabCloudPriceBook = this.priceBookData.find(function (v) { return v.text === "Rehab Cloud"; });
    };
    OpportunityUpgradeToStandardPre.prototype.decideUpgradeBaseDate = function () {
        if (this.upgradeToStandardDataList.length !== 0 &&
            value_checker_1.default.isBlank(this.salesForceInfo.upgradeToStandardBaseContractEndDate)) {
            var targetEndDate = null;
            targetEndDate = this.upgradeToStandardDataList.filter(function (value) {
                return value.familyName === "個別機能訓練加算" || value.familyName === "Rehab Cloud Basic";
            });
            this.salesForceInfo.upgradeToStandardBaseContractEndDate = targetEndDate[0].endDate;
        }
        else {
            this.alertMessage = "アップグレード対応でERRORが発生しています。開発にご連絡下さい";
            this.showAlertDialog = true;
        }
    };
    OpportunityUpgradeToStandardPre.prototype.defaultPriceBookData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var self_, authToken, url_, response, productItems, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (value_checker_1.default.isBlank(this.salesForceInfo.upgradeToStandardPriceBook2Id)) {
                            this.alertMessage = "アップグレード対応でERRORが発生しています。開発にご連絡下さい";
                            this.showAlertDialog = true;
                            return [2 /*return*/];
                        }
                        self_ = this;
                        self_.startLoading();
                        return [4 /*yield*/, this.$cognito.authToken()];
                    case 1:
                        authToken = _a.sent();
                        url_ = this.$invokeUrlMaker.create("sales_force/get_pricebook_entry/" + self_.salesForceInfo.upgradeToStandardPriceBook2Id);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, axios_1.default.get(url_, {
                                headers: {
                                    Authorization: "Bearer " + authToken
                                }
                            })];
                    case 3:
                        response = _a.sent();
                        productItems = null;
                        if (response.data['priceBookEntryList']) {
                            productItems = response.data['priceBookEntryList'];
                            productItems.unshift({
                                value: ' ',
                                text: String(self_.$t('dictionary.select.default_text')),
                                price: ' '
                            });
                        }
                        // 商品ファミリー「Rehab Cloud アップグレード」のみをフィルターする
                        self_.defaultPriceBookDataObj = productItems.filter(function (value) {
                            return value.family === "Rehab Cloud アップグレード";
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        self_.endLoading();
                        self_.alertDialogMessage = 'アップグレード対応でERRORが発生しています。開発にご連絡下さい';
                        self_.showAlertDialog = true;
                        return [2 /*return*/];
                    case 5:
                        self_.endLoading();
                        return [2 /*return*/];
                }
            });
        });
    };
    OpportunityUpgradeToStandardPre.prototype.submit = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var self_;
            return __generator(this, function (_a) {
                self_ = this;
                event.preventDefault();
                if (value_checker_1.default.isBlank(self_.salesForceInfo.torihikisakiId)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_torihikisaki_id').toString();
                    return [2 /*return*/];
                }
                if (value_checker_1.default.isBlank(self_.salesForceInfo.upgradeToStandardPriceBook2Id)) {
                    this.showAlertDialog = true;
                    this.alertMessage = this.$t('view.sales_force.reflect.msg.alert_pricebook_id').toString();
                    return [2 /*return*/];
                }
                if (this.isTokubetuBlank()) {
                    this.showAlertDialog = true;
                    this.alertMessage = "特別対応の詳細への入力は必須です";
                    return [2 /*return*/];
                }
                this.confirmMessage = '<strong>申込予定のRehab Cloud アップグレードの商品</strong>を登録します。よろしいですか？';
                this.confirmMessage += '<strong>申込みフォームでお客様が入力した契約開始日にもとづき、</strong><br>';
                this.confirmMessage += '<strong>ステップ２（SalesForceへの申込内容登録）にてアップグレード商品が選択できます。</strong>';
                this.showConfirmDialog = true;
                return [2 /*return*/];
            });
        });
    };
    OpportunityUpgradeToStandardPre.prototype.dialogClose = function () {
        this.showConfirmDialog = false;
        this.showAlertDialog = false;
    };
    OpportunityUpgradeToStandardPre.prototype.reflect = function () {
        var self_ = this;
        self_.dialogClose();
        this.$emit('reflect', this.getAjaxInfo());
    };
    OpportunityUpgradeToStandardPre.prototype.isTokubetuBlank = function () {
        return value_checker_1.default.isBlank(this.salesForceInfo.upgradeToStandardTokubetuDetail);
    };
    OpportunityUpgradeToStandardPre.prototype.getAjaxInfo = function () {
        // カラム追加した項目は、NullCareをしないと、trim()でエラー
        if (!this.salesForceInfo.upgradeToStandardId) {
            this.salesForceInfo.upgradeToStandardId = '';
        }
        if (!this.salesForceInfo.upgradeToStandardItemId) {
            this.salesForceInfo.upgradeToStandardItemId = '';
        }
        if (!this.salesForceInfo.torihikisakiId) {
            this.salesForceInfo.torihikisakiId = '';
        }
        return {
            salesForceInfo: {
                torihikisakiId: this.salesForceInfo.torihikisakiId.trim(),
                upgradeToStandardItFlg: this.salesForceInfo.upgradeToStandardItFlg,
                upgradeToStandardTokubetuFlg: this.salesForceInfo.upgradeToStandardTokubetuFlg,
                upgradeToStandardTokubetuDetail: this.salesForceInfo.upgradeToStandardTokubetuDetail,
                upgradeToStandardPriceBook2Id: this.salesForceInfo.upgradeToStandardPriceBook2Id,
                upgradeToStandardPriceBookData: this.defaultPriceBookDataObj,
                upgradeToStandardBaseContractEndDate: this.salesForceInfo.upgradeToStandardBaseContractEndDate,
                upgradeToStandardData: this.upgradeToStandardDataList.length === 0 ? this.salesForceInfo.upgradeToStandardData : this.upgradeToStandardDataList,
                upgradeToStandardFamilyName: this.upgradeToStandardFamilyNameList.length === 0 ? this.salesForceInfo.upgradeToStandardFamilyName : this.upgradeToStandardFamilyNameList,
                validUpgradeToStandardFlg: "true"
            },
            reflectType: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_UPGRADE_TO_STANDARD_PRE],
            fetchTypes: [ReflectType_1.SalesForceReflectType.OPPORTUNITY_UPGRADE_TO_STANDARD_PRE]
        };
    };
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityUpgradeToStandardPre.prototype, "initData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: {} })
    ], OpportunityUpgradeToStandardPre.prototype, "initSalesForceData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({
            default: function () {
            }
        })
    ], OpportunityUpgradeToStandardPre.prototype, "fetchSalesForceInfo", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityUpgradeToStandardPre.prototype, "priceBookData", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityUpgradeToStandardPre.prototype, "upgradeToStandardDataList", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: [] })
    ], OpportunityUpgradeToStandardPre.prototype, "upgradeToStandardFamilyNameList", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ default: false })
    ], OpportunityUpgradeToStandardPre.prototype, "isLinkComplete", void 0);
    __decorate([
        vue_property_decorator_1.Watch('initData')
    ], OpportunityUpgradeToStandardPre.prototype, "initDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('initSalesForceData')
    ], OpportunityUpgradeToStandardPre.prototype, "initSalesForceDataChange", null);
    __decorate([
        vue_property_decorator_1.Watch('salesForceInfo.upgradeToStandardPriceBook2Id')
    ], OpportunityUpgradeToStandardPre.prototype, "priceBook2IdChanged", null);
    OpportunityUpgradeToStandardPre = __decorate([
        vue_property_decorator_1.Component({
            components: {
                ProductSelect: ProductSelect_1.default,
                PriceBookSelect: PriceBookSelect_1.default,
                SimpleDialog: SimpleDialog_1.default,
                MoveSalesForceButton: MoveSalesForceButton_1.default,
                DatePickerWrapper: DatePickerWrapper_1.default,
                Loading: Loading_1.default,
                SalesForceButtonArea: SalesForceButtonArea_1.default,
                DetailDataSingleLabel: DetailDataSingleLabel_1.default
            }
        })
    ], OpportunityUpgradeToStandardPre);
    return OpportunityUpgradeToStandardPre;
}(vue_property_decorator_1.Vue));
exports.default = OpportunityUpgradeToStandardPre;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sales_force/OpportunityUpgradeToStandardPre.vue
// module id = ieRY
// module chunks = 1